import React from 'react';
import { TextInputRoot } from './components/root';
import { StyledTextInput } from './components/input';
import { TextInputProps, TextInputStateProps } from './model';
export type { TextInputProps } from './model';

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      size = 'normal',
      error = false,
      disabled = false,
      htmlType = 'text',
      sx,
      inputSx,
      value,
      startAdornment,
      endAdornment,
      rootRef,
      ...otherProps
    },
    ref,
  ) => {
    const [isFocused, setFocused] = React.useState(false);

    const ownerState: Required<TextInputStateProps> = {
      size,
      error,
      htmlType,
      disabled,
      focused: isFocused,
      startAdornment,
      endAdornment,
    } as Required<TextInputStateProps>;

    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <TextInputRoot ownerState={ownerState} ref={rootRef as any} sx={sx}>
        {startAdornment}
        <StyledTextInput
          disabled={disabled}
          onBlur={() => setFocused(false)}
          onFocus={() => setFocused(true)}
          ownerState={ownerState}
          ref={ref}
          sx={inputSx}
          type={htmlType}
          value={value}
          {...otherProps}
        />
        {endAdornment}
      </TextInputRoot>
    );
  },
);
